import type { PositionedText } from "../types";

// Browser-only: extract positioned text from a PDF using pdf.js.
// The heavy work runs in pdf.js's own worker, so nothing blocks the UI and
// (crucially) the file never leaves the device.
import * as pdfjs from "pdfjs-dist";
// Vite resolves this to a hashed URL for the worker bundle.
import workerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

export async function extractPositionedText(
  data: ArrayBuffer,
): Promise<PositionedText[]> {
  const doc = await pdfjs.getDocument({ data }).promise;
  const out: PositionedText[] = [];

  try {
    for (let pageNum = 1; pageNum <= doc.numPages; pageNum++) {
      const page = await doc.getPage(pageNum);
      const content = await page.getTextContent();

      for (const item of content.items) {
        // TextItem vs TextMarkedContent — only the former has `str`/`transform`.
        if (!("str" in item)) continue;
        const str = item.str;
        if (!str || !str.trim()) continue;

        // transform = [a, b, c, d, e, f]; e,f are the translation (x,y).
        const [a, , , d, e, f] = item.transform;
        out.push({
          text: str,
          x: e,
          y: f,
          width: item.width,
          height: item.height || Math.abs(d) || Math.abs(a),
          page: pageNum,
        });
      }

      page.cleanup();
    }
  } finally {
    await doc.destroy();
  }

  return out;
}
